import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["profileTab", "organizationTab", "profileSection", "organizationSection"]

  showProfile() {
    this.profileTabTarget.classList.add("mobile-account-tab--active")
    this.organizationTabTarget.classList.remove("mobile-account-tab--active")
    this.profileSectionTarget.classList.remove("d-none")
    this.organizationSectionTarget.classList.add("d-none")
  }

  showOrganization() {
    this.organizationTabTarget.classList.add("mobile-account-tab--active")
    this.profileTabTarget.classList.remove("mobile-account-tab--active")
    this.organizationSectionTarget.classList.remove("d-none")
    this.profileSectionTarget.classList.add("d-none")
  }
}
